/*
Monotype Foundry Platform API
Version 1.0.0

Definition: ReReleaseFamiliesRequest

Properties:
  foundryId: string (required)
  familyIds: array
  all: boolean
*/

var ReReleaseFamiliesRequest = (function () {
  function validateReReleaseFamiliesRequest (arg) {
    // Validate foundryId
    if (!arg.foundryId) {
      throw new Error('ReReleaseFamiliesRequest.foundryId: Missing property')
    }
    if (arg.foundryId && !(typeof arg.foundryId === 'string')) {
      throw new Error('ReReleaseFamiliesRequest.foundryId: Wrong type: Got \'' + (typeof arg.foundryId) + '\', but expected: \'string\'')
    }
    // Validate familyIds
    if (arg.familyIds && !(Array.isArray(arg.familyIds))) {
      throw new Error('ReReleaseFamiliesRequest.familyIds: Wrong type: Got \'' + (typeof arg.familyIds) + '\', but expected: \'array\'')
    }
    // Validate all
    if (arg.all && !(typeof arg.all === 'boolean')) {
      throw new Error('ReReleaseFamiliesRequest.all: Wrong type: Got \'' + (typeof arg.all) + '\', but expected: \'boolean\'')
    }
  }
  function buildReReleaseFamiliesRequest (arg) {
    var ReReleaseFamiliesRequest = arg
    // Complete foundryId
    // Expected Type: string
    ReReleaseFamiliesRequest.foundryId = ReReleaseFamiliesRequest.foundryId || ''
    // Complete familyIds
    // Expected Type: array
    ReReleaseFamiliesRequest.familyIds = ReReleaseFamiliesRequest.familyIds || []
    // Complete all
    // Expected Type: boolean
    ReReleaseFamiliesRequest.all = ReReleaseFamiliesRequest.all || false
    return ReReleaseFamiliesRequest
  }
  return {
    validate: validateReReleaseFamiliesRequest,
    build: buildReReleaseFamiliesRequest
  }
})()

module.exports = ReReleaseFamiliesRequest
